/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable arrow-body-style */
import React from 'react';
import { useSelector } from 'react-redux';
import {
  Navigate,
  Route,
  Routes,
  Switch,
  useLocation,
  useMatch
} from 'react-router-dom';
import WorkOrderDetails from '../../component/WorkOrder/WorkOrderDetails/WorkOrderDetails.view';
import WorkOrdersList from './WorkOrders';
import CreateWORoutes from './createWORoutes';
import { WO_CREATION_FROM } from '../../constants';
import { fetchUserAndLocation } from '../../component/Sidenav/fetchPageStatistics';

export const RouteComponent = ({ path }) => {
  return <Navigate to={`${path}`} />;
};

const WorkOrders = () => {
  const location = useLocation();
  const { pathname = '' } = useLocation();
  const match = useMatch(pathname);
  const { pathname: path = '' } = match || {};
  const { createdFrom } = location.state || {};
  const { type, workOrderCreationFrom } = useSelector(
    (state) => state.upsertWorkOrder
  );
  const updatedHomePath = path?.split('/')[2];

  return (
    <Routes>
      {type?.workflowTemplateId ||
      createdFrom === WO_CREATION_FROM.PLAN_DETAILS ? (
        <Route
          path='/create_WO/*'
          // exact={false}
          name='create_WO'
          // eslint-disable-next-line no-confusing-arrow
          element={<CreateWORoutes createdFrom={createdFrom} />}
        />
      ) : (
        <>
          <Route
            path={`${path}`}
            // exact={false}
            name='create_WO'
            // eslint-disable-next-line no-confusing-arrow
            element={<RouteComponent path={path} />}
          />
        </>
      )}

      <Route
        path='/:type/:workOrderId'
        exact
        name='create_WO'
        element={<WorkOrderDetails />}
      />
      <Route path='/' name='work_orders_list' element={<WorkOrdersList />} />
    </Routes>
  );
};

export default WorkOrders;
